import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, setSessionToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_token");
    const pendingState = sessionStorage.getItem("bbc.oauth_state");
    const validState = pendingState && pendingState === params.get("client_state");

    // clear hash from URL
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    if (!sessionId || !validState) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        sessionStorage.removeItem("bbc.oauth_state");
        setSessionToken(sessionId);
        const { data } = await api.get("/auth/me");
        setUser(data);
        if (data.is_admin) {
          navigate("/admin", { replace: true, state: { user: data } });
        } else {
          navigate("/admin/login", { replace: true });
        }
      } catch (e) {
        setSessionToken(null);
        await checkAuth();
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] text-[#5C6661]">
      Signing you in…
    </div>
  );
}
